export default "__VITE_ASSET__DHejjw63__"